import { Stack } from '@fluentui/react';
import React from 'react';

type SvgIconProps = {
  src: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  size?: number | string;
  color?: string;
  className?: string;
};

export const NavigationIcon: React.FC<SvgIconProps> = ({ src: Icon, size = 20, color = '#000', className }) => {
  return (
    <Stack className={className}>
      <Icon width={size} height={size} fill={color} aria-hidden="true" />
    </Stack>
  );
};
